import { createContext, useEffect, useState } from 'react';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import UtilNotify from '../../utils/UtilNotify';
import UtilObject from '../../utils/UtilObject';
import UserActions from '../../actions/UserActions';
import MyFlex from '../../components/myFlex/MyFlex';
import SettingsLayoutMenu from './SettingsLayoutMenu';
import useWindowSize from '../../hooks/useWindowSize';
import LoadingIconAppAbsolute from '../../components/loadingIconApp/LoadingIconAppAbsolute';
import './SettingsLayout.scss';

const { Content } = Layout;

export const UserContext = createContext();

const SettingsLayout = ({ children, fullPage }) => {
  const { isMobile } = useWindowSize();

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(UtilObject.EMPTY_OBJECT);

  const idUser = useSelector((state) => {
    return state.currentUser?.idUser;
  });

  useEffect(() => {
    if (!idUser) return;
    const fill = async () => {
      setLoading(true);
      const resultGetOne = await UserActions.getOne(idUser);
      if (resultGetOne.success) {
        setUserData(resultGetOne.data);
      } else {
        UtilNotify.notifyErrorServer(resultGetOne.errMsg);
      }
      setLoading(false);
    };
    fill();
  }, [idUser]);

  const changeUserSettings = (values) => {
    setUserData((ov) => ({ ...ov, ...values }));
  };

  const contentWidth = fullPage || isMobile ? '100%' : '50%';
  const contentClassName = fullPage || isMobile ? '' : 'max_width_650px';

  const contentStyle = {
    width: contentWidth,
    ...(fullPage || isMobile ? { maxWidth: contentWidth } : {}),
  };

  return (
    <UserContext.Provider value={{ userData, changeUserSettings }}>
      <Layout>
        <MyFlex vertical={isMobile}>
          <SettingsLayoutMenu />
          <Content className={contentClassName} style={contentStyle}>
            {loading ? (
              <LoadingIconAppAbsolute height="84vh" />
            ) : userData?.idUser ? (
              children
            ) : null}
          </Content>
        </MyFlex>
      </Layout>
    </UserContext.Provider>
  );
};

export default SettingsLayout;
